import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

import * as Sentry from "@sentry/angular";

/**
 * Targets for W3C trace propagation (sentry-trace, baggage) on outgoing HTTP.
 * Built from env hosts only — no query/body. / أهداف بث رؤوس التتبع دون query أو body
 */
function buildTracePropagationTargets(apiBaseUrl: string, adminApiBaseUrl: string): (string | RegExp)[] {
  const hosts = new Set<string>(['localhost', '127.0.0.1']);
  try {
    hosts.add(new URL(apiBaseUrl).host);
    hosts.add(new URL(adminApiBaseUrl).host);
  } catch {
    /* ignore malformed URLs */
  }
  return [...hosts];
}

Sentry.init({
  dsn: "https://eb6e67a80c49a1c77745ffa77e430cd5@o4509300876705792.ingest.de.sentry.io/4509306828095568",
  sendDefaultPii: true,
  integrations: [Sentry.browserTracingIntegration()],
  tracesSampleRate: environment.sentry.tracesSampleRate,
  tracePropagationTargets: buildTracePropagationTargets(environment.apiBaseUrl, environment.adminApiBaseUrl),
  replaysSessionSampleRate: 0, // Optional: user session replays
  replaysOnErrorSampleRate: 0,  // Optional: full replay if error occurs
  release: environment.appVersion, // if you manage releases
  environment: environment.name,    // use the `name` field from environment.ts
});

 

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.error(err));
